export const SFX = { eat: '/audio/eat.mp3', click: '/audio/click.mp3' } as const;
